import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { ErrorDetails } from '../../authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';

export class GetQRDataWhatsApp extends IRequestCommand<
  IGetQRDataWhatsAppResponse,
  ErrorDetails,
  IGetQRDataWhatsAppParameters> {
  override _commandType: CommandRequestType = CommandRequestType.PUT;
  override _commandUrl = 'carriers/{carrierId}/AutoResponder';

  public override setParameters(parameters: IGetQRDataWhatsAppParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierId}',
      parameters.idCarrier ? parameters.idCarrier.toString() : ''
    );
    this._commandBody = parameters;
  }
}

export interface IGetQRDataWhatsAppParameters extends ICommandParameters {
  username: string;
  password: string;
  idCarrier: string;
  lang: string;
  path: string;
  car?: string;
  option?: string;
  message?: string;
  selectOption?: string;
  messageHelp?: string;
  messageOther?: string;
  responderType?: string;
}

export interface IGetQRDataWhatsAppResponse extends ICommandResponse {
  url?: string;
}
